import React, { Component } from 'react';
import Loader from 'react-loader';
import firebase from "./Firebase"

export default class ResetPassword extends Component {
  state = {
    email: null,
    error: '',
    password: '',
    confirmPassword: '',
    success: false,
    validCode: null,
    verifiedCode: false,
    submitted: false,
    showAlert: false,
    loadSpinner: false
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  continueHandler = () => {
    this.props.history.push("/SignIn")
  }

  componentDidMount() {
    // Verify the password reset code is valid.
    firebase.auth()
      .verifyPasswordResetCode(this.props.actionCode)
      .then(email => {
        this.setState({ email, validCode: true, verifiedCode: true });
      }, error => {
        // Invalid or expired action code. Ask user to try to reset the password
        // again.
        this.setState({ error: error.message, validCode: false, verifiedCode: true });
      });
  }

  handleResetPassword = (event) => {
    event.preventDefault();
    this.setState({ submitted: true });
    const { actionCode } = this.props;
    const newPassword = this.state.password;
    const confirmPassword = this.state.confirmPassword;

    if (!(newPassword && confirmPassword)) {
      return
    }

    if (newPassword !== confirmPassword) {
      this.setState({ error: 'Password & Confirm Password are not same.', showAlert: true });
      return
    }
    this.setState({ loadSpinner: true });
    firebase.auth()
      .confirmPasswordReset(actionCode, newPassword)
      .then(() => {
        this.setState({ loadSpinner: false, success: true });
      }, error => {
        this.setState({ loadSpinner: false, error: error.message, showAlert: true });
      });
  }

  setText = (evt) => {
    this.setState({ password: evt.target.value });
  }

  render() {
    const {
      email,
      error,
      password,
      confirmPassword,
      success,
      validCode,
      verifiedCode,
      showAlert,
      submitted,
      loadSpinner
    } = this.state;

    let component;
    if (!verifiedCode) {
      component = (<div className="text-xs-center spinnerHome">
        <Loader className="loader" color='#6f2c91' scale={1.5} loaded={false} />
      </div>);
    } else if (success) {
      component = (
        <div className="login-register-page container page">
          <div className="row form-container">
            <div className="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-6  col-xs-8 form-center form-box" >
              <h6 className="text-center">Password Reset successfully.</h6><br />
              <button autoFocus className="btn btn-primary btn-block" onClick={this.continueHandler}>Sign In</button>
            </div>
          </div>
        </div>
      );
    } else if (verifiedCode && validCode) {
      component = (
        <div className="login-register-page container page">
          <div className="row form-container">
            <div className="col-lg-4 col-lg-offset-4 col-md-6 col-md-offset-6 col-sm-6 col-sm-offset-6 col-xs-8 form-center form-box">
              <div className={"alert alert-danger text-center" + (showAlert ? " show" : " hide")}>{error}</div>
              <h5 className="text-center">Reset Password</h5>
              <div className="break-line"><strong>{email}</strong></div><br />
              <form name="form" onSubmit={this.handleResetPassword} >              
              <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
                <h6>Password</h6>
                <input type="password" className="form-control" name="password" value={password} onChange={this.handleChange} minlength="6" placeholder="At least 6 characters" />
                {submitted && !password &&
                  <div className="help-block">Password is required</div>
                }
              </div>
              <div className={'form-group' + (submitted && !confirmPassword ? ' has-error' : '')}>
                <h6>Confirm Password</h6>
                <input type="password" className="form-control" name="confirmPassword" value={confirmPassword} onChange={this.handleChange} minlength="6" placeholder="At least 6 characters" />
                {submitted && !confirmPassword &&
                  <div className="help-block">Confirm Password is required</div>
                }
              </div>
              <div className="form-group" className="mt-2 text-xs-center">
                  {loadSpinner && <Loader className="loader text-xs-center" color='#6f2c91' scale='0.48' loaded={false} />}
                  <button className="btn btn-primary btn-block" disabled={loadSpinner}>Reset</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      );
    } else if (verifiedCode && !validCode) {
      component = (
        <div className="login-register-page container page">
          <div className="row form-container">
            <div className="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-6  col-xs-8 form-center form-box">
              <h6>Try resetting your password again</h6><br />
              <div className="alert alert-danger text-center">{error}</div>
            </div>
          </div>
        </div>
      );
    }

    return component;
  }
}



// WEBPACK FOOTER //
// ./src/components/ResetPassword.js